import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { ReactSession } from "react-client-session";
import { tokens } from "../dashboard/theme";
import NavigationHeader from "../components/NavigationHeader";
import config from "./global/config";
import {
  AddProduitModal,
  EditProduitModal,
  DeleteProduitModal,
} from "./ProduitModals";
import { usePermissions } from "./hooks/usePermissions";

function Produit() {
  const { hasPermission } = usePermissions();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [data, setData] = useState([]);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [dataCategorie, setDataCategorie] = useState([]);
  const [dataCategories, setDataCategories] = useState([]);
  const [dataMarques, setDataMarques] = useState([]);
  const [dataMarqueById, setDataMarqueById] = useState([]);

  const [produitSelected, setProduitSelected] = useState({
    id_produit: "",
    id_categorie: "",
    reference: "",
    categorie_code: "",
    unite: "",
    tva: "",
    designation: "",
    description: "",
    id_marque: "",
    marque_desc: "",
    categorie_desc: "",
    prix_achat: "",
    prix_vente: "",
    stock_minimum: "",
    stock_actuel: "",
    garantie: "",
    user_cre: "",
    user_upd: "",
  });

  const api = axios.create({
    baseURL: config.apiUrl,
  });

  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const clearSelected = () => {
    setProduitSelected({
      id_produit: "",
      id_categorie: "",
      reference: "",
      categorie_code: "",
      unite: "",
      tva: "",
      designation: "",
      description: "",
      id_marque: "",
      marque_desc: "",
      categorie_desc: "",
      prix_achat: "",
      prix_vente: "",
      stock_minimum: "",
      stock_actuel: "",
      garantie: "",
      user_cre: "",
      user_upd: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduitSelected((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const openCloseModalInsert = () => {
    setModalAdd(!modalAdd);
    if (!modalAdd) clearSelected();
    setDataMarques([]);
  };

  const openCloseModalEdit = () => {
    setModalEdit(!modalEdit);
    modalEdit === false
      ? setDataMarques([])
      : requestGetMarques(selectProduit.id_marque);
  };

  const openCloseModalDelete = () => {
    setModalDelete(!modalDelete);
  };

  const requestGet = async () => {
    try {
      const response = await api.get("produits.php");
      setData(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.log(error);
    }
  };

  const requestGetCategorie = async () => {
    try {
      const response = await api.get("selection.php", {
        params: { categorie: "" },
      });

      // console.log("Categorie response:", response.data);

      const categorie = Array.isArray(response.data) ? response.data : [];
      setDataCategorie(categorie);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.error("Error fetching categorie:", error);
      setDataCategorie([]);
    }
  };

  const requestGetCategories = async () => {
    try {
      const response = await api.get("categories.php");

      console.log("Categories response:", response.data);

      const categories = Array.isArray(response.data) ? response.data : [];
      setDataCategories(categories);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.error("Error fetching categories:", error);
      setDataCategories([]);
    }
  };

  const requestGetMarques = async (id) => {
    try {
      const response = await api.get("marques.php", {
        params: { id_categorie: id },
      });

      console.log("Marques response:", response.data);

      const marques = Array.isArray(response.data) ? response.data : [];
      setDataMarques(marques);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.error("Error fetching marques:", error);
      setDataMarques([]);
    }
  };

  const requestGetMarqueById = async (id) => {
    try {
      const response = await api.get("marques.php", {
        params: { id_marque: id },
      });

      console.log("Marques response:", response.data);

      const marques = Array.isArray(response.data) ? response.data : [];
      setDataMarqueById(marques);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.error("Error fetching marques:", error);
      setDataMarqueById([]);
    }
  };

  const requestPost = async () => {
    try {
      const formData = new FormData();
      formData.append("id_categorie", produitSelected.id_categorie);
      formData.append("reference", produitSelected.reference);
      formData.append("categorie_code", produitSelected.categorie_code);
      formData.append("unite", produitSelected.unite);
      formData.append("tva", produitSelected.tva);
      formData.append("designation", produitSelected.designation);
      formData.append("description", produitSelected.description);
      formData.append("id_marque", produitSelected.id_marque);
      formData.append("prix_achat", produitSelected.prix_achat);
      formData.append("prix_vente", produitSelected.prix_vente);
      formData.append("stock_minimum", produitSelected.stock_minimum);
      formData.append("stock_actuel", produitSelected.stock_actuel);
      formData.append("garantie", produitSelected.garantie);
      formData.append("user_cre", ReactSession.get("username"));
      formData.append("METHOD", "POST");

      const response = await api.post("produits.php", formData);

      if (
        typeof response.data === "string" &&
        response.data.includes("Error")
      ) {
        throw new Error(response.data);
      }

      if (
        Array.isArray(response.data) ||
        (typeof response.data === "object" && response.data.id_produit)
      ) {
        requestGet();
        openCloseModalInsert();
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }

      alert(error.message || "Error adding produit. Please try again.");
      console.error(error);
    }
  };

  const requestPut = async () => {
    try {
      const formData = new FormData();
      formData.append("id_categorie", produitSelected.id_categorie);
      formData.append("reference", produitSelected.reference);
      formData.append("categorie_code", produitSelected.categorie_code);
      formData.append("unite", produitSelected.unite);
      formData.append("tva", produitSelected.tva);
      formData.append("designation", produitSelected.designation);
      formData.append("description", produitSelected.description);
      formData.append("id_marque", produitSelected.id_marque);
      formData.append("prix_achat", produitSelected.prix_achat);
      formData.append("prix_vente", produitSelected.prix_vente);
      formData.append("stock_minimum", produitSelected.stock_minimum);
      formData.append("stock_actuel", produitSelected.stock_actuel);
      formData.append("garantie", produitSelected.garantie);
      formData.append("user_upd", ReactSession.get("username"));
      formData.append("METHOD", "PUT");

      await api.post(
        `produits.php?id_produit=${produitSelected.id_produit}`,
        formData
      );
      requestGet();
      openCloseModalEdit();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.error(error);
    }
  };

  const requestDelete = async () => {
    try {
      const formData = new FormData();
      formData.append("METHOD", "DELETE");

      await api.post(
        `produits.php?id_produit=${produitSelected.id_produit}`,
        formData
      );
      setData(
        data.filter(
          (produit) => produit.id_produit !== produitSelected.id_produit
        )
      );
      openCloseModalDelete();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        window.location.href = "/login";
      }
      console.log(error);
    }
  };

  const selectProduit = (produit, action) => {
    setProduitSelected(produit);
    console.log("Selected produit:", produit);

    if (action === "Edit") {
      openCloseModalEdit();
    } else {
      openCloseModalDelete();
    }
  };

  const columns = [
    {
      field: "reference",
      headerName: "Référence",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "designation",
      headerName: "Désignation",
      flex: 1.2,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1.8,
    },
    {
      field: "famille_desc",
      headerName: "Famille",
      flex: 1,
    },
    {
      field: "marque_desc",
      headerName: "Marque",
      flex: 1,
    },
    {
      field: "unite",
      headerName: "Unité",
      flex: 0.5,
    },
    {
      field: "tva",
      headerName: "TVA",
      flex: 0.5,
    },
    {
      field: "prix_achat",
      headerName: "Prix Achat",
      flex: 1,
    },
    {
      field: "prix_vente",
      headerName: "Prix Vente",
      flex: 1,
    },
    {
      field: "stock_minimum",
      headerName: "Stock Minimum",
      flex: 1,
    },
    {
      field: "stock_actuel",
      headerName: "Stock Actuel",
      flex: 1,
    },
    {
      field: "garantie",
      headerName: "Garantie",
      flex: 0.6,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: (params) => {
        const actions = [];

        if (hasPermission("produit", "edit")) {
          actions.push(
            <GridActionsCellItem
              icon={<EditIcon />}
              label="Edit"
              onClick={() => selectProduit(params.row, "Edit")}
              color="inherit"
            />
          );
        }

        if (hasPermission("produit", "delete")) {
          actions.push(
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => selectProduit(params.row, "Delete")}
              color="inherit"
            />
          );
        }

        return actions;
      },
    },
  ];

  useEffect(() => {
    requestGet();
    requestGetCategorie();
    requestGetCategories();
  }, []);

  return (
    <Box m="25px">
      <NavigationHeader title="Produits" subtitle="Liste des Produits" />

      <Box display="flex" justifyContent="end" mt="20px">
        {hasPermission("produit", "add") && (
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            onClick={openCloseModalInsert}
          >
            Nouveau Produit
          </Button>
        )}
        <AddProduitModal
          open={modalAdd}
          handleClose={openCloseModalInsert}
          handleSubmit={(e) => {
            e.preventDefault();
            requestPost();
          }}
          produitData={produitSelected}
          handleChange={(e) => {
            requestGetMarques(e.target.value);
            console.log(e.target.value);
            handleChange(e);
          }}
          categorie={dataCategorie}
          categories={dataCategories}
          marques={dataMarques}
        />

        <EditProduitModal
          open={modalEdit}
          handleClose={openCloseModalEdit}
          handleSubmit={(e) => {
            e.preventDefault();
            requestPut();
          }}
          produitData={produitSelected}
          handleChange={(e) => {
            requestGetMarques(e.target.value);
            console.log(e.target.value);
            handleChange(e);
          }}
          categorie={dataCategorie}
          categories={dataCategories}
          marques={dataMarques}
        />

        <DeleteProduitModal
          open={modalDelete}
          handleClose={openCloseModalDelete}
          handleDelete={requestDelete}
          produit={produitSelected}
        />
      </Box>

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.secondary,
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={data}
          getRowId={(row) => row.id_produit}
          columns={columns}
          slots={{
              toolbar: CustomToolbar,
            }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
            },
          }}
        />
      </Box>
    </Box>
  );
}

// CustomToolbar and other components remain the same...

// CSV Export Options
const csvOptions = {
  fileName: "ProduitsDatabase",
  delimiter: ";",
  utf8WithBom: true,
};

// Print Export Options
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
  includeCheckboxes: true,
};

// Custom Export Buttons Component
function CustomExportButtons(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <GridPrintExportMenuItem options={printOptions} />
    </GridToolbarExportContainer>
  );
}

// Custom Toolbar Component
function CustomToolbar(props) {
  return (
    <GridToolbarContainer {...props}>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <CustomExportButtons />
      <Box
        sx={{
          marginLeft: "auto",
          pl: 0,
          pr: 0,
          pb: 0,
          pt: 0,
        }}
      >
        <GridToolbarQuickFilter />
      </Box>
    </GridToolbarContainer>
  );
}

export default Produit;
